try {
  module.exports = require('./node')
} catch (e) {
  module.exports = require('./js')
}



//////////////////
// WEBPACK FOOTER
// ./~/scrypt.js/index.js
// module id = 985
// module chunks = 0 1 2